import { createContext, useCallback, useContext, useEffect, useState } from "react";
import i18n from "../i18n";
import { api, TOKEN_KEY } from "./api";
import { clearDemo } from "./demo";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);
export const NEXT_KEY = "valeriia_next";

export function AuthProvider({ children }) {
  const [me, setMe] = useState(undefined);

  const applyMe = useCallback((data) => {
    setMe(data);
    const lang = data?.user?.interface_language;
    if (lang && lang !== i18n.language && !localStorage.getItem("valeriia_lang_manual")) i18n.changeLanguage(lang);
  }, []);

  const refresh = useCallback(async () => {
    if (!localStorage.getItem(TOKEN_KEY)) return setMe(null);
    try {
      const { data } = await api.get("/auth/me");
      applyMe(data);
      return data;
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setMe(null);
    }
  }, [applyMe]);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);

  const signIn = async (token) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.removeItem("valeriia_lang_manual");
    return refresh();
  };
  const signOut = () => {
    localStorage.removeItem(TOKEN_KEY);
    clearDemo();
    setMe(null);
  };

  return <AuthCtx.Provider value={{ me, setMe: applyMe, refresh, signIn, signOut }}>{children}</AuthCtx.Provider>;
}

export function landingFor(me) {
  if (!me?.user?.role_choice) return "/onboarding";
  return me.user.active_role === "owner" ? "/owner" : "/home";
}
